import { useState } from 'react';
import { RegistrationWizard } from '../registration/RegistrationWizard.js';
import { RegistrationComplete } from '../registration/RegistrationComplete.js';
import { learnerGetSteps } from '../registration/minorSteps.js';
import { emptyRegFormData, type RegFormData } from '../registration/types.js';
import { submitRegistration } from '../registration/submit.js';

export function RegisterLearnerView() {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [doneEmail, setDoneEmail] = useState<string | null>(null);

  async function onSubmit(data: RegFormData) {
    setError(null);
    setSubmitting(true);
    try {
      await submitRegistration('learner', data);
      setDoneEmail(data.email);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  if (doneEmail) return <RegistrationComplete email={doneEmail} role="learner" />;
  return (
    <RegistrationWizard
      heading="Learner registration"
      getSteps={learnerGetSteps}
      initialData={emptyRegFormData()}
      submitting={submitting}
      error={error}
      onSubmit={onSubmit}
    />
  );
}
